import { useParams } from 'react-router-dom';

import { AppPollsPage } from '~/components/pages/AppPollsPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const AppPollsRoute: React.FC = () => {
  const { appId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppPollsPage appId={appId} />
    </DashboardTemplate>
  );
};
